// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"94":"Login","778":"Profile"}[chunkId] + "." + {"94":"ecf6f8e0","778":"3d3fde85"}[chunkId] + ".chunk.css";
};